// You can write your custom Javascript here
jQuery(document).ready(function () {
  // jQuery('.radio.radio--color.disabled').parent().remove();

  // Wedding date is now optional — no validation needed

  $(".em-wdgt-products").each(function (elmnt) {
    $(this).html('<img src="//cdn.shopify.com/s/files/1/0300/7401/t/180/assets/bc-sf-filter-loading.gif" />');
    render_products($(this));
  });

  function render_products(elmnt) {
    let widget = $(elmnt);
    let handle = widget.data("collection");
    let color = lower_case(widget.data("color"));
    let limit = widget.data("size");
    $.get("https://www.kennedyblue.com/collections/" + handle + "/products.json", function (data) {
      let products = data.products;
      let html_data = '<div class="products-grid">';
      for (var i = 0; i < products.length; i++) {
        if (i >= limit) {
          break;
        }
        html_data += get_product_data(products[i], color);
      }
      html_data += '</div>';
      widget.html(html_data);
    });
  }

  function get_product_data(product, color) {
    let variants = product['variants'];
    let variant = variants[0];
    if (color != null && color != undefined) {
      for (var i = 0; i < variants.length; i++) {
        if (lower_case(variants[i]['option1']) == color || lower_case(variants[i]['option2']) == color || lower_case(variants[i]['option3']) == color) {
          variant = variants[i];
          break;
        }
      }
    }
    let product_url = "/products/" + product["handle"] + "?variant=" + variant["id"];
    return '<div class="product-grid"><div class="product-item-inner"><div class="product-item-image"><a href="' + product_url + '"><img src="' + variant['featured_image']['src'] + '" /></a></div><div class="product-bottom"><a href="' + product_url + '" class="product-item-title">' + product['title'] + '</a><p class="product-item-price"><span class="product-item-regular-price">$&nbsp;' + variant['price'] + '</span></p></div></div></div>';
  }

  function lower_case(str) {
    if (str == null || str == undefined) {
      return str;
    }

    return str.toString().toLowerCase();
  }
});

// Wedding date checkout validation removed — field is now optional

$(document).ready(async function () {
  // We'll take our estimate hash from a <meta> tag, we fetch it here
  const $headCartEstimate = document.querySelector('meta[name="cart-estimate-hash"]');
  if (!$headCartEstimate) {
    console.warn('Cart estimate header not found!');
    return;
  }

  // This is the estimate hash we'll be storing and checking against
  const CART_ESTIMATE_HASH = $headCartEstimate.getAttribute('content');

  // This is the local storage key we'll be using to track the value above
  const CART_ESTIMATE_KEY = 'kb-cart-estimate-hash';

  // This needs to match the property name used elsewhere!
  const PROP_DELIVERY_DATE_NAME = 'Estimated Delivery on or Before';

  // This represents the types of estimate we support
  const ESTIMATE_TYPES = {
    standard: 'standard',
    rush: 'rush',
  };

  // Helper functions

  function getCart() {
    return fetch('/cart.js')
      .then(response => response.json());
  }

  function updateLineItem(id, data) {
    return fetch('/cart/change.js', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...data,
        id,
      }),
    }).then(response => response.json());
  }

  function updateLineItemProperties(lineItem, properties) {
    return updateLineItem(lineItem.key, {
      properties: Object.assign({}, lineItem.properties, properties),
    });
  }

  function getEstimateType(estimate) {
    for (let type in ESTIMATE_TYPES) {
      const regex = new RegExp(ESTIMATE_TYPES[type], 'i');
      if (regex.test(estimate)) {
        return type;
      }
    }
    return 'standard';
  }

  async function getUpdatedEstimatedDelivery(lineItem) {
    const responseHtml = await (
      fetch(`/products/${lineItem.handle}?variant=${lineItem.variant_id}`)
        .then(response => response.text())
    );

    // Let's parse our current estimate type
    const currentEstimate = lineItem.properties[PROP_DELIVERY_DATE_NAME];
    const currentEstimateType = getEstimateType(currentEstimate);

    // Let's convert our response into something we can query
    const $response = $(responseHtml);

    // And now, let's get whatever is available as estimates
    const $estimates = $response.find(`[name="properties[${PROP_DELIVERY_DATE_NAME}]"] option`);
    const availableEstimates = {};
    $estimates.each((i, o) => {
      const estimate = $(o).attr('value');
      const estimateType = getEstimateType(estimate);
      availableEstimates[estimateType] = estimate;
    });

    // Extract the new extimate and return it, but if not found, returns the current estimate
    const newEstimate = availableEstimates[currentEstimateType];

    return {
      lineItem,
      estimate: newEstimate || currentEstimate,
    };
  }

  // Actual logic for the function

  // Fetches last value and compares, if nothing changed, nothing needs to be updated
  const lastHash = localStorage.getItem(CART_ESTIMATE_KEY);

  // If no previous hash is found, let's just save a new hash value
  if (!lastHash) {
    localStorage.setItem(CART_ESTIMATE_KEY, CART_ESTIMATE_HASH);
    return;
  }

  // Skips whenever the hashes match, too
  if (lastHash == CART_ESTIMATE_HASH) {
    return;
  }

  // Loads cart, gets a list of line items that have a set delivery date
  const cart = await getCart();
  const lineItemsWithEstimatedDelivery = (cart.items || []).filter(
    lineItem => !!lineItem.properties[PROP_DELIVERY_DATE_NAME]
  );

  if (lineItemsWithEstimatedDelivery.length > 0) {
    // Fetches new estimates from the product pages in parallel
    const estimates = await Promise.all(
      lineItemsWithEstimatedDelivery.map(lineItem => getUpdatedEstimatedDelivery(lineItem))
    );

    // Sends parallel requests to update each line item with the new delivery date
    await Promise.all(
      estimates.map(result => {
        const updatedProperties = {};
        updatedProperties[PROP_DELIVERY_DATE_NAME] = result.estimate;
        return updateLineItemProperties(result.lineItem, updatedProperties);
      })
    );
  }

  // Saves new value for the cart hash
  localStorage.setItem(CART_ESTIMATE_KEY, CART_ESTIMATE_HASH);
});


if (document.querySelector('.nav .nav__dropdown .nav__dropdown')) {
  document.querySelectorAll('.nav .nav__dropdown .nav__dropdown').forEach(el => {
    if (jQuery(window).width() >= 768) {
      let cont = el.closest('.shell').querySelector('.dropdown-menu');
      let contH = jQuery(cont).outerHeight(true);
      let titleH = jQuery(cont.querySelector('.dropdown-menu-title')).outerHeight(true);
      let linkH = jQuery(el.closest('.nav__item').querySelector('a')).outerHeight(true);
      el.style.marginTop = "-" + (titleH + linkH - 18) + "px";
      el.style.minHeight = contH + "px";
    }
  });
}

if (document.querySelector('.nav .nav__dropdown .nav__dropdown')) {
  document.querySelectorAll('.nav .nav__dropdown .nav__dropdown').forEach(el => {
    if (jQuery(window).width() < 768) {
      let links = el.closest('.nav__item').querySelectorAll('&> a');
      if(links.length > 0) {
        links.forEach(link => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            //link.classList.toggle('is-active');
            showNavDropdownsForMobile(link)
          });
        });
      }
    }
  });
}

if(typeof showNavDropdownsForMobile == "undefined") {
  function showNavDropdownsForMobile($clickedElement) {
    let mobileWidth = 767;
    $clickedElement = jQuery($clickedElement);
    if (jQuery(window).width() > mobileWidth) {
      $clickedElement.parent().addClass('is-active').siblings().removeClass('is-active');
    } else {
      if(!$clickedElement.hasClass('is-active')) {
        $clickedElement.addClass('is-active').next('.nav__dropdown').slideDown().closest('li').siblings().find('.is-active').removeClass('is-active').next('.nav__dropdown').slideUp();
      }
      else {
        $clickedElement.removeClass('is-active').next('.nav__dropdown').slideUp().closest('li').siblings().find('.is-active').removeClass('is-active').next('.nav__dropdown').slideUp();
      }
    }
  }
}


if(typeof genFx == "undefined") {
  function genFx( type, includeWidth ) {
    var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
    var which,
      i = 0,
      attrs = { height: type };

    // If we include width, step value is 1 to do all cssExpand values,
    // otherwise step value is 2 to skip over Left and Right
    includeWidth = includeWidth ? 1 : 0;
    for ( ; i < 4; i += 2 - includeWidth ) {
      which = cssExpand[ i ];
      attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
    }

    if ( includeWidth ) {
      attrs.opacity = attrs.width = type;
    }

    return attrs;
  }
}

// Generate shortcuts for custom animations
jQuery.each( {
  slideDown: genFx( "show" ),
  slideUp: genFx( "hide" ),
  slideToggle: genFx( "toggle" ),
  fadeIn: { opacity: "show" },
  fadeOut: { opacity: "hide" },
  fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
  jQuery.fn[ name ] = function( speed, easing, callback ) {
    return this.animate( props, speed, easing, callback );
  };
} );

// Listen's to changes on BCSF's grids and emits update events for integration with other parts of the site
(function (selectors) {
  function emitEvents($element, $wrapper, mutation) {
    function dispatchNewItem($node) {
      document.dispatchEvent(new CustomEvent('custom:boost-new-item', {
        detail: {
          item: $node,
          wrapper: $wrapper,
        },
      }));
    }
    
    // Initially present items
    if (!mutation) {
      dispatchNewItem($element);
      return;
    }

    // Handles added elements
    mutation.addedNodes.forEach($node => dispatchNewItem($node));
  }
  function attemptToInitialize($boostWrapper) {
    // If we haven't initialized, stop and return false
    const $boostViews = Array.from($boostWrapper.querySelectorAll(selectors));
    if ($boostViews.length === 0) {
      return false;
    }
    
    // Starts obvserving our lists for new items
    const boostItemsMutationObserver = new MutationObserver((mutationList, observer) => {
      mutationList.forEach(mutation => emitEvents(mutation.target, $boostWrapper, mutation));
    });
    $boostViews.forEach($boostView => {
      Array.from($boostView.children || []).forEach($element => emitEvents($element, $boostWrapper, null));
      boostItemsMutationObserver.observe($boostView, { childList: true })
    });

    // Return true so we can tell it has been initialized
    return true;
  }

  selectors = (selectors || []).join(', ');
  document.querySelectorAll('#bc-sf-filter-wrapper').forEach($boostWrapper => {
    // If we have initialized here, just hook
    if (attemptToInitialize($boostWrapper)) {
      return;
    }

    // If not, let's wait for initialization
    const initObserver = new MutationObserver((mutationList, observer) => attemptToInitialize($boostWrapper) && observer.disconnect());
    initObserver.observe($boostWrapper, { childList: true, subtree: true });
  });
})(['.bc-sf-filter-grid-view-items']);

// Resilience: Delegated listener for color changes (fixes issues when apps like Globo replace the options)
$(document).on('change', '.js-colors-change input, .radio--color input', function() {
    const $input = $(this);
    const $label = $input.next('label');
    const colorHandle = $label.data('handle') || $input.val();
    
    const $productSlider = $('.js-slider-product');
    const $thumbs = $('.js-slider-thumbs');
    
    if (window.createProductSlides) {
        if ($productSlider.length) {
            $productSlider.attr('data-color', colorHandle);
            window.createProductSlides($productSlider, colorHandle);
        }
        if ($thumbs.length) {
            $thumbs.attr('data-color', colorHandle);
            window.createProductSlides($thumbs, colorHandle);
        }
    }
});

// Resilience: Watchdog to ensure sliders are populated even if events are missed or blocked
$(function() {
    let attempts = 0;
    const maxAttempts = 10;
    
    const sliderWatchdog = setInterval(() => {
        attempts++;
        const $productSlider = $('.js-slider-product');
        const $thumbs = $('.js-slider-thumbs');
        
        // If sliders exist but are empty, try to populate them
        if (window.createProductSlides && window.productImages && window.productImages.images && window.productImages.images.length > 0) {
            if ($productSlider.length && $productSlider.children().length === 0) {
                const color = $productSlider.attr('data-color') || 'rosewood';
                window.createProductSlides($productSlider, color);
            }
            if ($thumbs.length && $thumbs.children().length === 0) {
                const color = $thumbs.attr('data-color') || 'rosewood';
                window.createProductSlides($thumbs, color);
            }
            
            // If populated, we can stop
            if (($productSlider.length === 0 || $productSlider.children().length > 0) &&
                ($thumbs.length === 0 || $thumbs.children().length > 0)) {
                clearInterval(sliderWatchdog);
            }
        }
        
        if (attempts >= maxAttempts) {
            clearInterval(sliderWatchdog);
        }
    }, 1000);
});